import React from 'react';
import { gql, useQuery } from '@apollo/client';
import { Link } from 'react-router-dom';

// WordPress'ten son 5 yazıyı çekmek için GraphQL sorgusu
const GET_LATEST_POSTS = gql`
  query GetLatestPosts {
    posts(first: 5, where: { orderby: { field: DATE, order: DESC } }) {
      nodes {
        id
        title
        slug
        date
      }
    }
  }
`;

function LatestPosts() {
  // useQuery hook'u ile sorguyu çalıştır
  const { loading, error, data } = useQuery(GET_LATEST_POSTS);

  // Yüklenme durumu göstergesi
  if (loading) return <p>Yazılar yükleniyor...</p>;

  // Hata durumu göstergesi
  if (error) {
    console.error("Apollo Hata:", error); // Hatanın detayını konsola yazdır
    return <p>Hata oluştu: {error.message}. Lütfen konsolu kontrol edin.</p>;
   }

  // Veri başarıyla geldiğinde ve yazılar varsa listele
  return (
    <div>
      <h2>Son Yazılar</h2>
      {data && data.posts && data.posts.nodes.length > 0 ? (
        <ul>
          {data.posts.nodes.map((post) => (
            <li key={post.id}>
              {/* Başlığı Link bileşeni ile sarmala */}
              {/* `to` prop'u yönlendirilecek URL'yi belirtir */}
              {/* Template literal kullanarak dinamik URL oluşturuyoruz */}
              <Link to={`/yazi/${post.slug}`}>
                {post.title}
              </Link>
              {' '}- {new Date(post.date).toLocaleDateString()}
            </li>
          ))}
        </ul>
      ) : (
        // Yazı bulunamazsa veya data.posts.nodes boşsa
        <p>Gösterilecek yazı bulunamadı.</p>
      )}
    </div>
  );
}

export default LatestPosts;